const AUTH_PATH_PREFIXES = [
  "/sign-in",
  "/sign-up",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
];

function isBlockedAuthPath(pathname) {
  return AUTH_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

/**
 * Resolves a safe in-app path after sign-in from React Router `state.from`.
 */
export function getPostAuthRedirectPath(from, fallback = "/") {
  if (!from || typeof from !== "object") return fallback;

  const pathname = from.pathname;
  if (typeof pathname !== "string" || !pathname.startsWith("/")) {
    return fallback;
  }

  if (isBlockedAuthPath(pathname)) {
    return fallback;
  }

  const search = typeof from.search === "string" ? from.search : "";
  const hash = typeof from.hash === "string" ? from.hash : "";
  return `${pathname}${search}${hash}`;
}
